export var PDFDocumentType;
(function (PDFDocumentType) {
    PDFDocumentType["TRANSACTION_EXPORT"] = "TRANSACTION_EXPORT";
    PDFDocumentType["INVOICE"] = "INVOICE";
    PDFDocumentType["BANK_STATEMENT"] = "BANK_STATEMENT";
    PDFDocumentType["ACCOUNT_SUMMARY"] = "ACCOUNT_SUMMARY";
    PDFDocumentType["CRYPTO_TRANSACTIONS"] = "CRYPTO_TRANSACTIONS";
    PDFDocumentType["SELF_CUSTODY_CRYPTO_TRANSACTIONS"] = "SELF_CUSTODY_CRYPTO_TRANSACTIONS";
    PDFDocumentType["TRADEVEST_RECEIPT"] = "TRADEVEST_RECEIPT";
})(PDFDocumentType || (PDFDocumentType = {}));
export var PDFRequestStatus;
(function (PDFRequestStatus) {
    PDFRequestStatus["PENDING"] = "PENDING";
    PDFRequestStatus["PROCESSING"] = "PROCESSING";
    PDFRequestStatus["COMPLETED"] = "COMPLETED";
    PDFRequestStatus["FAILED"] = "FAILED";
})(PDFRequestStatus || (PDFRequestStatus = {}));
export var PDFDeliveryMethod;
(function (PDFDeliveryMethod) {
    PDFDeliveryMethod["EMAIL"] = "email";
    PDFDeliveryMethod["DOWNLOAD"] = "download";
})(PDFDeliveryMethod || (PDFDeliveryMethod = {}));
//# sourceMappingURL=pdf.types.js.map